<template>
<div class="RMCShowSingleResult">
  <div class="RMCShowSingleResultTitle">
    {{ roundData.name }}
  </div>
  <div class="iconClose-Corner">
    <CrossWhiteIcon @click="closePopover" />
  </div>
  <div class="RMCShowSingleResultDate"> {{ $t('no.') }} {{ roundData.round }}</div>
  <div class="RMCShowSingleResultDate">{{ roundData.createdDate }}</div>
  <div class="flipSummary-bull-container-all">
    <div class="flipSummary-bull-container-top h74">
      <div class="flipSummary-bull-container-top-result flipSummary-bull-container-top-result-1">
        <div v-if="roundData.score.playerCard3Number !== ''" class="flipSummary-bull-card-holder-10-summary flipSummary-bull-card-zIndex-0">
          <div class="flipResult-barh-card" >
            <div class="flipResult-barh-card-front flipResult-barh-card-number-black">
              <div class="flipResult-barh-card-number"
                :class="classNumberColor(roundData.score.playerCard3Suit)"
              >
                {{ roundData.score.playerCard3Number }}
              </div>
              <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-1">
                <component :is="classSuit(roundData.score.playerCard3Suit)" />
              </div>
            </div>
          </div>
        </div>
        <div class="flipSummary-bull-card-holder-11-summary flipSummary-bull-card-zIndex-1">
          <div class="flipResult-barh-card" >
            <div class="flipResult-barh-card-front flipResult-barh-card-number-black">
              <div class="flipResult-barh-card-number"
                :class="classNumberColor(roundData.score.playerCard2Suit)"
              >
                {{ roundData.score.playerCard2Number }}
              </div>
              <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-1">
                <component :is="classSuit(roundData.score.playerCard2Suit)" />
              </div>
            </div>
          </div>
        </div>
        <div class="flipSummary-bull-card-holder-12-summary flipSummary-bull-card-zIndex-2">
          <div class="flipResult-barh-card" >
            <div class="flipResult-barh-card-front flipResult-barh-card-number-black">
              <div class="flipResult-barh-card-number"
                :class="classNumberColor(roundData.score.playerCard1Suit)"
              >
                {{ roundData.score.playerCard1Number }}
              </div>
              <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-1">
                <component :is="classSuit(roundData.score.playerCard1Suit)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="result-vline-thick flipSummary-bull-vline"></div>
      <div class="flipSummary-bull-container-top-result flipSummary-bull-container-top-result-2">
        <div class="flipSummary-bull-card-holder-10-summary flipSummary-bull-card-zIndex-0">
          <div class="flipResult-barh-card" >
            <div class="flipResult-barh-card-front flipResult-barh-card-number-black">
              <div class="flipResult-barh-card-number"
                :class="classNumberColor(roundData.score.bankerCard1Suit)"
              >
                {{ roundData.score.bankerCard1Number }}
              </div>
              <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-1">
                <component :is="classSuit(roundData.score.bankerCard1Suit)" />
              </div>
            </div>
          </div>
        </div>
        <div class="flipSummary-bull-card-holder-11-summary flipSummary-bull-card-zIndex-1">
          <div class="flipResult-barh-card" >
            <div class="flipResult-barh-card-front flipResult-barh-card-number-black">
              <div class="flipResult-barh-card-number"
                :class="classNumberColor(roundData.score.bankerCard2Suit)"
              >
                {{ roundData.score.bankerCard2Number }}
              </div>
              <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-1">
                <component :is="classSuit(roundData.score.bankerCard2Suit)" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="roundData.score.bankerCard3Number !== ''" class="flipSummary-bull-card-holder-12-summary flipSummary-bull-card-zIndex-2">
          <div class="flipResult-barh-card" >
            <div class="flipResult-barh-card-front flipResult-barh-card-number-black">
              <div class="flipResult-barh-card-number"
                :class="classNumberColor(roundData.score.bankerCard3Suit)"
              >
                {{ roundData.score.bankerCard3Number }}
              </div>
              <div class="flipResult-barh-card-front-image flipResult-barh-card-front-image-1">
                <component :is="classSuit(roundData.score.bankerCard3Suit)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flipSummary-bull-container-headline">
      <div class="flipSummary-bull-text">Người chơi</div>
      <div class="flipSummary-bull-text">Nhà cái</div>
    </div>
    <div class="flipSummary-bull-container-bottom">
      <div class="flipSummary-bull-container-score-all-2">
        <div class="flipSummary-barh-container-2">
          <div class="result-box fr-main-bg flipSummary-barh-result-box">
            <span>{{ roundData.score.playerCardTotal }}</span>
          </div>
          <div class="result-box fr-main-bg flipSummary-barh-result-box">
            <span>{{ roundData.score.bankerCardTotal }}</span>
          </div>
        </div>
        <div class="flipSummary-barh-container-2">
          <div class="result-box fr-main-bg flipSummary-barh-result-box">
            {{ $t('WINNER_' + roundData.score.result) }}
          </div>
        </div>
        <div class="flipSummary-barh-container-2">
          <div class="result-box fr-main-bg flipSummary-barh-result-box">
            {{ $t('DOUBLE_' + roundData.score.doublePlayer) }}
          </div>
          <div class="result-box fr-main-bg flipSummary-barh-result-box">
            {{ $t('DOUBLE_' + roundData.score.doubleBanker) }}
          </div>
        </div>
        <!-- <div class="flipSummary-pk10-sum">
          <div class="flipResult-sum-sum-container">
            <div class="flipResult-sum-total fr-main-txt ">Tổng lá bài</div>
            <div class="flipResult-sum-value">
              {{ roundData.score.totalCards }}
            </div>
          </div>
          <div class="result-vline-thin flipSummary-pk10-vline"></div>
          <div class="result-box fr-main-bg flipSummary-pk10-result-box">
            {{ $t(roundData.score.bigSmall) }}
          </div>
        </div>
        <div class="result-hline flipSummary-pk10-hLine"></div>
        <div class="flipSummary-pk10-sum">
          <div class="flipResult-sum-sum-container">
            <div class="flipResult-sum-total fr-main-txt ">Tổng điểm</div>
            <div class="flipResult-sum-value">
              {{ roundData.score.totalNumbers }}
            </div>
          </div>
          <div class="result-vline-thin flipSummary-pk10-vline"></div>
          <div class="result-box fr-main-bg flipSummary-pk10-result-box">
            {{ $t(roundData.score.totalBigSmall) }}
          </div>
          <div class="result-box fr-main-bg flipSummary-pk10-result-box">
            {{ $t(roundData.score.totalOddEven) }}
          </div>
        </div> -->
      </div>
    </div>
  </div>

</div>

</template>

<script>
import CrossWhiteIcon from '@assets/icons/cross-white.svg';
import SpadeSign from '@assets/icons/spade-sign.svg';
import HeartSign from '@assets/icons/heart-sign.svg';
import ClubSign from '@assets/icons/club-sign.svg';
import DiamondSign from '@assets/icons/diamond-sign.svg';

export default {
  components: {
    CrossWhiteIcon,
    SpadeSign,
    HeartSign,
    ClubSign,
    DiamondSign,
  },
  props: {
    roundData: {
      type: Object,
      default: () => ({
        name: { type: String, default: "" },
        value: { type: String, default: "" },
        round: { type: Number, default: 0 },
        score: { type: Object, default: () => ({})},
        createdDate: { type: String, default: "" },
      })
    }
  },
  methods: {
    closePopover() {
      // console.log('HistoryDetail - closePopover')
      this.$emit('closePopover');
    },
    classSuit: function(value) {
      switch(value){
        case 1: return SpadeSign;
        case 2: return ClubSign;
        case 3: return DiamondSign;
        case 4: return HeartSign;
      }
    },
    classWinLoss: function(value) {
      return this.score.result === value ? "bacarat-win" : "bacarat-loss";
    },
    classNumberColor: function(suit) {
      return suit > 2 ? "flipResult-barh-card-number-red" : "flipResult-barh-card-number-black";
    },
  }
}
</script>

<style>

</style>
